module.exports = __webpack_public_path__ + "img/bells.ffcd5568.svg";